import { useTranslation } from 'react-i18next';
import { MdArrowBack } from 'react-icons/md';
import {
  FacialRegistrationProvider,
  useFacialRegistrationContext,
  FACIAL_STEPS,
} from '../../../../../store/FacialRegistration';
import { usePersonalizedInviteContext } from '../../../../../store/PersonalizedInvite/provider';
import FacialRegistrationFlow from './FacialRegistrationFlow';
import * as S from './styles';

const FacialRegistrationContent = () => {
  const [t] = useTranslation('personalized-invite');
  const { step, goToInvitePage } = useFacialRegistrationContext();

  const showBackButton = step === FACIAL_STEPS.PREPARATION;

  return (
    <S.PageContainer>
      <S.Header>
        {showBackButton ? (
          <S.BackButton onClick={goToInvitePage}>
            <MdArrowBack size={24} />
          </S.BackButton>
        ) : (
          <S.Spacer />
        )}
        <S.HeaderTitle>{t('facial-registration.header-title')}</S.HeaderTitle>
        <S.Spacer />
      </S.Header>

      <S.ContentArea>
        <FacialRegistrationFlow />
      </S.ContentArea>
    </S.PageContainer>
  );
};

const FacialRegistration = () => {
  const { customization } = usePersonalizedInviteContext();

  return (
    <FacialRegistrationProvider
      primaryColor={customization?.primaryColor}
      secondaryColor={customization?.primaryColor}
    >
      <FacialRegistrationContent />
    </FacialRegistrationProvider>
  );
};

export default FacialRegistration;
